// Email format validation + common-typo domain suggestions (e.g. gmial.com -> gmail.com)

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Popular domains we suggest corrections towards
const COMMON_DOMAINS = [
  'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.in', 'yahoo.co.in',
  'hotmail.com', 'outlook.com', 'live.com', 'icloud.com', 'me.com',
  'rediffmail.com', 'ymail.com', 'protonmail.com', 'aol.com',
];

const COMMON_TLDS = ['com', 'in', 'org', 'net', 'co.in', 'edu', 'gov'];

export function isValidEmailFormat(email) {
  if (!email) return false;
  return EMAIL_REGEX.test(String(email).trim());
}

function levenshtein(a, b) {
  const m = a.length, n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
    }
  }
  return dp[m][n];
}

function closest(candidate, list, maxDistance) {
  let best = null;
  let bestDist = Infinity;
  for (const item of list) {
    if (item === candidate) return null; // already correct
    const d = levenshtein(candidate, item);
    if (d < bestDist) { bestDist = d; best = item; }
  }
  return bestDist > 0 && bestDist <= maxDistance ? best : null;
}

// Returns a corrected email string suggestion, or null if none.
export function getEmailSuggestion(email) {
  if (!email) return null;
  const trimmed = String(email).trim();
  const at = trimmed.lastIndexOf('@');
  if (at < 1 || at === trimmed.length - 1) return null;

  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1).toLowerCase();
  if (!domain.includes('.')) return null;
  if (COMMON_DOMAINS.includes(domain)) return null;

  // 1) Whole-domain closeness to a popular domain (handles gmial.com, gmail.con, gmail.co)
  const domainFix = closest(domain, COMMON_DOMAINS, 2);
  if (domainFix) return `${local}@${domainFix}`;

  // 2) TLD-only typo (e.g. mycompany.con -> mycompany.com)
  const lastDot = domain.lastIndexOf('.');
  const name = domain.slice(0, lastDot);
  const tld = domain.slice(lastDot + 1);
  const tldFix = closest(tld, COMMON_TLDS, 1);
  if (tldFix) return `${local}@${name}.${tldFix}`;

  return null;
}
